export const onlyNumber = (numInput: any) => {
  if (!numInput) return;

  const pnum = numInput?.toString().match(/\d/g)?.join("");
  const pureNum = pnum?.split(".")[0]?.replace(/\,/g, "");

  return pureNum;
};
